import { httpsCallable } from "firebase/functions";
import { db, functions } from "../../firebase/firebase";
import { collection, getDocs, query, Timestamp, where } from "firebase/firestore";
import { nameofTutorPaymentSchemaCollection, nameofTutorPaymentSchemaPaid, TutorPaymentSchema, TutorPaymentView } from "../Types/TutorPaymentSchema";
import { nameofSessionSchemaCollection, nameofSessionSchemaCompleted, SessionSchema, SessionView } from "../Types/BookingSchema";
import moment from "moment-timezone";

export async function executeDbTransforms() {
    const dbTransforms = httpsCallable(functions, "dbTransforms");

    await dbTransforms();
}

export async function updateTOS() {
    const updateTOS = httpsCallable(functions, 'updateTOS');
    
    return updateTOS();
}

export async function getTutorPayments() {
    const tutorPayments = [] as TutorPaymentView[];
    const tutorPaymentDocs = collection(db, nameofTutorPaymentSchemaCollection);

    const tutorPaymentQuery = query(tutorPaymentDocs, where(nameofTutorPaymentSchemaPaid, "==", false));

    const snapshot = await getDocs(tutorPaymentQuery);
    for (const doc of snapshot.docs) {
        tutorPayments.push({
            Id: doc.id,
            ...doc.data() as TutorPaymentSchema
        });
    }

    return tutorPayments;
}

export async function getUpComingTutorSessions() {
    const upcomingTutorSessions = [] as SessionView[];
    const tutorPaymentDocs = collection(db, nameofSessionSchemaCollection);

    const now = moment().startOf("day").toDate();

    const tutorPaymentQuery = query(tutorPaymentDocs, where(nameofSessionSchemaCompleted, "==", false), where("SessionTimeStamp", ">=", Timestamp.fromDate(now)));

    const snapshot = await getDocs(tutorPaymentQuery);
    for (const doc of snapshot.docs) {
        upcomingTutorSessions.push({
            Id: doc.id,
            ...doc.data() as SessionSchema
        });
    }

    return upcomingTutorSessions;
}

export async function payTutorPayments(paymentIds: string[]) {
    const payTutorPayments = httpsCallable(functions, "payTutorPayments");

    return payTutorPayments({ paymentIds });
}